import React, { useEffect, useState, useRef } from "react"
import dayjs from "dayjs"
import { TimePicker } from "antd"
import locale from "antd/es/date-picker/locale/pt_BR"
import moment from "moment"

import styles from "./index.module.scss"
import Label from "../Label"
import ClockIcon from "../../../assets/icons/ClockIcon"
import Button from "../Button"

function fnIsValidTime(time) {
  try {
    const bIsValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(time)
    return bIsValid
  } catch {
    return false
  }
}

function RcmpTimePickerFooter(props) {
  const { fnOnClose } = props
  return (
    <div className={styles.timePickerFooter}>
      <Button liquid={true} onClick={fnOnClose}>
        SELECIONAR
      </Button>
    </div>
  )
}

const RcmpTimePicker = React.forwardRef((props, ref) => {
  const { cLabel, disabled, defaultValue, width, ...oRest } = props

  const [bIsOpen, fnSetBIsOpen] = useState(false)
  const [dSelectedTime, fnSetDSelectedTime] = useState()

  const eltimeRContainerRef = useRef(null)

  function fnHandleOnSelect(oValue) {
    const timeString = oValue.format("HH:mm")
    fnSetDSelectedTime(timeString)
    props.onChange(timeString)
  }

  function fnOnClose() {
    fnSetBIsOpen(false)
  }

  function fnOnInputTimerChange() {
    const timeInputValue =
      eltimeRContainerRef.current.firstChild.firstChild.firstChild.value
    if (fnIsValidTime(timeInputValue)) {
      const dFormatedTime = dayjs(timeInputValue, "HH:mm")
      fnSetDSelectedTime(dFormatedTime.format("HH:mm"))
      props.onChange(dFormatedTime.format("HH:mm"))
    }
  }

  const cClass = `${styles.timePickerContainer} ${disabled ? styles.timePickerDisabled : ""
    }`

  const dValue = dSelectedTime
    ? dayjs(dSelectedTime, "HH:mm")
    : defaultValue
      ? dayjs(defaultValue, "HH:mm")
      : null

  return (
    <div
      className={cClass}
      style={{ width: width ? width : "100%" }}
      onClick={(e) => e.stopPropagation()}
    >
      <Label>{cLabel}</Label>
      <div onChange={fnOnInputTimerChange} ref={eltimeRContainerRef} >
        <TimePicker

          autoComplete="off"
          ref={ref}
          open={bIsOpen}
          onOpenChange={fnSetBIsOpen}
          changeOnBlur={true}
          format="HH:mm"
          placeholder="--:--"
          value={dValue}
          showNow={false}
          allowClear={false}
          popupClassName={styles.timepicker}
          suffixIcon={<ClockIcon fill="#6CB6E3" />}
          onSelect={fnHandleOnSelect}
          disabled={disabled}
          defaultValue={dayjs(defaultValue, "HH:mm")}
          renderExtraFooter={() => <RcmpTimePickerFooter fnOnClose={fnOnClose} />}
          locale={{
            ...locale,
            lang: {
              ...locale.lang,
              ok: "Selecionar",
            },
          }}
          {...oRest}
        />
      </div>
    </div>
  )
})

RcmpTimePicker.displayName = "RcmpTimePicker"

export default RcmpTimePicker
